// tslint:disable:no-useless-computed-key
import { TFunction } from 'i18next'

interface VehicleType {
    id: string
    color: string
    label: string
    icon?: string
}

export const VehicleTypesOptions = (t: TFunction): VehicleType[] => {
    return [
        {
            id: 'compact_car',
            color: '#000',
            label: t('profile.vehicle.vehicleTypes.compact_car'),
            icon: 'wemolo-car-small'
        },
        {
            id: 'wagon',
            color: '#000',
            label: t('profile.vehicle.vehicleTypes.wagon'),
            icon: 'wemolo-car-kombi'
        },
        {
            id: 'suv',
            color: '#000',
            label: t('profile.vehicle.vehicleTypes.suv'),
            icon: 'wemolo-car-suv'
        },
        {
            id: 'family_van',
            color: '#000',
            label: t('profile.vehicle.vehicleTypes.family_van'),
            icon: 'wemolo-car-van'
        },
        {
            id: 'camper_van',
            color: '#000',
            label: t('profile.vehicle.vehicleTypes.camper_van'),
            icon: 'wemolo-car-bus'
        },
        {
            id: 'motorhome',
            color: '#000',
            label: t('profile.vehicle.vehicleTypes.motorhome'),
            icon: 'wemolo-camping-car'
        },
        {
            id: 'delivery_van',
            color: '#000',
            label: t('profile.vehicle.vehicleTypes.delivery_van'),
            icon: 'wemolo-truck'
        },
        {
            id: 'trailer',
            color: '#000',
            label: t('profile.vehicle.vehicleTypes.trailer'),
            icon: 'wemolo-car-trailer'
        }
    ]
}

export const VehicleIdToIcon = (id: string): string => {
    switch (id.toLowerCase()) {
        case 'compact_car':
            return 'wemolo-car-small'
        case 'wagon':
            return 'wemolo-car-kombi'
        case 'suv':
            return 'wemolo-car-suv'
        case 'family_van':
            return 'wemolo-car-van'
        case 'camper_van':
            return 'wemolo-car-bus'
        case 'motorhome':
            return 'wemolo-camping-car'
        case 'delivery_van':
            return 'wemolo-truck'
        case 'trailer':
            return 'wemolo-car-trailer'
        default:
            return 'pkd-car-small'
    }
}
